/**
 * @generated SignedSource<<58a9f07c2558c98d458bd18f33013098>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateHistoryForBoardInput = {
  affectedBoardId?: string | null;
  clientMutationId?: string | null;
};
export type BoardDepositHistoryMutation$variables = {
  input: CreateHistoryForBoardInput;
};
export type BoardDepositHistoryMutation$data = {
  readonly createHistoryForBoard: {
    readonly history: {
      readonly rowId: number;
    } | null;
  } | null;
};
export type BoardDepositHistoryMutation = {
  response: BoardDepositHistoryMutation$data;
  variables: BoardDepositHistoryMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BoardDepositHistoryMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateHistoryForBoardPayload",
        "kind": "LinkedField",
        "name": "createHistoryForBoard",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "History",
            "kind": "LinkedField",
            "name": "history",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BoardDepositHistoryMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateHistoryForBoardPayload",
        "kind": "LinkedField",
        "name": "createHistoryForBoard",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "History",
            "kind": "LinkedField",
            "name": "history",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6ca85e2589993b0c3124c3c7170aa1f6",
    "id": null,
    "metadata": {},
    "name": "BoardDepositHistoryMutation",
    "operationKind": "mutation",
    "text": "mutation BoardDepositHistoryMutation(\n  $input: CreateHistoryForBoardInput!\n) {\n  createHistoryForBoard(input: $input) {\n    history {\n      rowId\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "482cc8273c1882631edeaf7a4e3bedc4";

export default node;
